export default __webpack_public_path__ + "static/media/snarkify.3dd468fb.svg";